import React from 'react'
import styled from 'styled-components'
import SbEditable from 'storyblok-react'

import { useOpenModalFromEvent } from 'hooks'
import { media } from 'utils'

import { Container, Col } from 'components/Grid'
import { Section } from 'components/Common'
import Slider from 'components/Slider'
import EventCard from '../EventCard'
import HubSpotFormModal from '../EventFormModal'

import { StyledRow, Title, ChildCol, MaxCountCol } from './styles'
import WithEvents from '../WithEvents'

function EventsSimple({ blok, isMobile, allEvents, lang }) {
  const { modalOpen, toggleModalVisibility } = useOpenModalFromEvent()

  const maxAmount = blok.max_amount * 1

  const events = maxAmount ? allEvents.slice(0, maxAmount) : allEvents
  const eventsWithModals = events.filter(event => event.content.signup_form && event.content.signup_form.length > 0)
  console.log({ allEvents, eventsWithModals })

  /* Methods */
  const renderEvent = props =>
    <EventContent
      {...props}
      locale={lang}
      no_location={Boolean(blok.no_location)}
      heading="h4"
      key={props.uuid}
      toggleModalVisibility={toggleModalVisibility}
    />

  return (
    <SbEditable content={blok}>
      <Section
        paddingTop={blok.padding_top || 106}
        paddingBottom={blok.padding_bottom || 64}
        paddingTopMb={blok.padding_top_mobile || 120}
        paddingBottomMb={blok.padding_bottom_mobile || 80}
        css="background-color: transparent;"
      >
        <Container>
          <StyledRow marginTop={blok.margin_top || 0} marginTopBm={blok.margin_top_mobile || 0}>
            <Col width={[1]} px={0} css="text-align: center;">
              <Title>{blok.heading}</Title>
            </Col>
            {events.length > 2 ? (
              <ChildCol width={[1]} px={0}>
                <Slider
                  isMobile={isMobile}
                  setting={{
                    ...(isMobile ? { slidesToShow: 1 } : { slidesToShow: 2 }),
                    equalItemsHeight: true,
                  }}
                  nextArrowCss="top: 20px !important;"
                  prevArrowCss={
                    isMobile
                      ? 'top: 20px !important; left: 90px !important; z-index: 10;'
                      : 'top: 20px !important; z-index: 10;'
                  }
                >
                  {events.map(renderEvent)}
                </Slider>
              </ChildCol>
            ) : (
              <MaxCountCol width={[1]} px={0}>
                {events.map((el, i) => {
                  return (
                    <ColEventWrapper key={`event_element__${i}`} width={[1, 1, 1 / 2, 3.5 / 10]} px={[0, 24]}>
                      {renderEvent(el)}
                    </ColEventWrapper>
                  )
                })}
              </MaxCountCol>
            )}
          </StyledRow>
        </Container>
      </Section>

      {eventsWithModals.length > 0 && eventsWithModals.map(event => event.uuid === modalOpen && (
        <HubSpotFormModal
          handleCloseModal={toggleModalVisibility}
          content={event.content}
          key={event.uuid}
        />
      ))}
    </SbEditable>
  )
}

export default WithEvents(EventsSimple)

const ColEventWrapper = styled(Col)`
  display: flex;
`

const EventContent = styled(EventCard)`
  padding: 46px 22px 57px 23px;
  border: 1px solid ${({ theme }) => theme.colors.neutral};
  max-width: 320px !important;
  margin-top: 70px;

  h4 {
    min-height: 80px;
  }

  div {
    max-width: 290px !important;
    margin: 0;
  }

  ${media.greaterThan('350px')`
    max-width: 350px !important;
    display: flex !important;
    margin-left: auto;
    margin-right: auto;
  `}
  ${media.greaterThan('lg')`
    max-width: 428px !important;
    padding: 66px 69px 68px 69px;
    margin-top: 70px;
    margin-left: 0;
    margin-right: 0;
  `}
`
